export default __webpack_public_path__ + "static/circle-d0d77143e8de3ec4421e6c41fb1ec194.png";